module.exports = "https://la-static.vkplay.ru/promo/newstart/img/artist.668bef2e.png";